import React from 'react';
import { Button, Modal } from '@iwoca/orion';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './DirectorModal.module.css';

type Props = {
  showModal: boolean;
  closeModal: () => void;
};

export const DirectorModal: React.FunctionComponent<Props> = ({
  showModal,
  closeModal,
}) => {
  const { trackEvent } = useAmplitude();

  const COMPANY_HOUSE_URL =
    'https://find-and-update.company-information.service.gov.uk/';

  return (
    <Modal
      onClose={closeModal}
      isOpen={showModal}
      title="Your client needs to be a director of their company"
      size="medium"
      className={styles.modal}
    >
      <p className={styles.content}>
        Check with the applicant that they are correctly listed as a director of
        their company on{' '}
        <a
          onClick={() => {
            trackEvent(AMPLITUDE_EVENTS.externalLinkClicked, {
              'CTA destination': 'Companies house',
              'CTA text': 'Companies House',
              'CTA URL': COMPANY_HOUSE_URL,
            });
          }}
          className={styles.link}
          href={COMPANY_HOUSE_URL}
          target="_blank"
          rel="noreferrer"
        >
          Companies House
        </a>
        .
      </p>
      <Button type="button" className={styles.button} onClick={closeModal}>
        I understand
      </Button>
    </Modal>
  );
};
